/* eslint-disable default-case */

import {
    SET_ACTIVE_LOCATION,
    SET_INITIAL_ACTIVE_LOCATION,
    GET_RECENT_SEARCH_LOCATIONS,
    CREATE_RECENT_SEARCH_LOCATION
} from '../actions/locationActions';

const initialState = {
    activeLocation: undefined,
    activeLocationIsLoading: false,
    lastError: undefined,
    recentSearchLocations: [],
    recentSearchLocationsIsLoading: false,
    recentSearchLocationsError: undefined,
    createSearchLocationIsLoading: false,
    createSearchLocationError: undefined
};

export function location(state = initialState, action) {
    switch (action.type) {
        case SET_ACTIVE_LOCATION.pending:
        {
            return {
                ...state,
                activeLocationIsLoading: true
            };
        }
        case SET_INITIAL_ACTIVE_LOCATION: // Set initial active location just subverts the API call to set the initial values on load.
        case SET_ACTIVE_LOCATION.fulfilled:
        {
            return {
                ...state,
                lastError: undefined,
                activeLocationIsLoading: false,
                activeLocation: action.payload
            };
        }
        case SET_ACTIVE_LOCATION.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                activeLocationIsLoading: false
            };
        }
        case GET_RECENT_SEARCH_LOCATIONS.pending:
        {
            return {
                ...state,
                recentSearchLocationsIsLoading: true
            };
        }
        case GET_RECENT_SEARCH_LOCATIONS.fulfilled:
        {
            return {
                ...state,
                recentSearchLocationsIsLoading: false,
                recentSearchLocationsError: undefined,
                recentSearchLocations: action.payload
            };
        }
        case GET_RECENT_SEARCH_LOCATIONS.rejected:
        {
            return {
                ...state,
                recentSearchLocationsIsLoading: false,
                recentSearchLocationsError: action.payload
            };
        }
        case CREATE_RECENT_SEARCH_LOCATION.pending:
        {
            return {
                ...state,
                createSearchLocationIsLoading: true
            };
        }
        case CREATE_RECENT_SEARCH_LOCATION.fulfilled:
        {
            return {
                ...state,
                recentSearchLocations: action.payload,
                createSearchLocationIsLoading: false,
                createSearchLocationError: undefined
            };
        }
        case CREATE_RECENT_SEARCH_LOCATION.rejected:
        {
            return {
                ...state,
                createSearchLocationIsLoading: false,
                createSearchLocationError: action.payload
            };
        }
    }

    return state;
}
